import {
  Injectable
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  environment
} from './../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ClientProcessService {

  private URI =
    environment.URL_API;

  constructor(
    private http: HttpClient
  ) { }

  async getProcessesByClient(
    clientId: string
  ) {

    return await this.http
      .get<any>(

        this.URI +
        '/clients-process/client/' +
        clientId

      )
      .toPromise();
  }

  async createProcess(
    payload: any
  ) {

    return await this.http
      .post<any>(

        this.URI +
        '/clients-process',

        payload

      )
      .toPromise();
  }

  async updateProcess(
    processId: string,
    payload: any
  ) {

    return await this.http
      .put<any>(

        this.URI +
        '/clients-process/' +
        processId,

        payload

      )
      .toPromise();
  }

  async deleteProcess(
    processId: string
  ) {

    return await this.http
      .delete<any>(

        this.URI +
        '/clients-process/' +
        processId

      )
      .toPromise();
  }

}